<template>
  <div v-if="canInvest">
    <BaseButton
      v-if="canDecline"
      :title="$t('I decline')"
      :to="`/opportunities/${$route.params.id}/wish/decline`"
      theme="outlined"

      class="flex-1 mb-4 border-t border-strong-shadow-color pt-4"
      @click="trackDecline"
    />
    <BaseButton
      :to="`/opportunities/${$route.params.id}/wish/new`"
      :title="title"
      :theme="theme"
      class="mb-6 md:mb-0"
      @click="trackInvest"
    />
  </div>
</template>

<script>
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import BaseOrangeText from '../../components/BaseOrangeText.vue';
import BaseButton from '../../components/BaseButton.vue';
import { CLICKED_INVEST_BUTTON, CLICKED_DECLINED_BUTTON } from '../../analytics';

export default {
  name: 'InvestButton',
  components: {
    BaseSectionHeader,
    BaseOrangeText,
    BaseButton,
  },
  props: {
    canInvest: {
      type: Boolean,
      default: true,
    },
    canDecline: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    theme() {
      if (this.disabled) {
        return 'disabled';
      }
      return 'primary';
    },
    title() {
      if (this.disabled) {
        return this.$t('Opening soon');
      }
      return this.$t('I want to invest');
    },
  },
  methods: {
    trackInvest() {
      analytics.track(CLICKED_INVEST_BUTTON);
    },
    trackDecline() {
      analytics.track(CLICKED_DECLINED_BUTTON);
    },
  },
};
</script>
